import React from 'react'
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n'; // initialized i18next instance

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import PrequalForm from './PrequalForm.jsx'
import Products from './Products.jsx'
import ServiceAvailable from './ServiceAvailable.jsx'
import MduModal from './MduModal.jsx'
import SquallMduModal from './SquallMduModal.jsx';
import PrequalProgress from './PrequalProgress.jsx'
import NoService from './NoService.jsx'
import AddressNotFound from './AddressNotFound.jsx'

import CouponNotice from './CouponNotice.jsx'
import TempUnavail from './TempUnavail.jsx'
import ContactThanks from './ContactThanks.jsx'
import BusinessSeats from './BusinessSeats.jsx'
import SmallBusiness from './SmallBusiness.jsx'
//import BusinessOptions from './BusinessOptions.jsx'

import OrderStages from './OrderStages.jsx'
import SquallSuggestionsModal from './SquallSuggestionsModal.jsx'

import Reseller from './Reseller.jsx'

import FiberXGSPON from './FiberXGSPON.jsx'
import FiberXGSPONPreorder from './FiberXGSPONPreorder.jsx'
import FiberOnly from './FiberOnly.jsx'
import FiberPreOrder from './FiberPreOrder.jsx'
import './LongScroll.css'

import { translate } from 'react-i18next';

var Availability = React.createClass({

	getInitialState() {
		return {store: AvailabilityStore.getState()};
	},

	componentDidMount() {
		AvailabilityStore.listen(this.onChange);
	},

	componentWillUnmount() {
		AvailabilityStore.unlisten(this.onChange);
	},

	onChange(state) {
		this.setState({store: state});
	},

    placeOrder() {
        AvailabilityActions.placeOrder(this.state.store.toJS());
    },

  render() {
		const { t } = this.props;
        var store = this.state.store;
        const tempProducts = store.get('products').toJS();

		var stepOne, className, mduModal, squallMduModal, placeOrder, hidden, couponNotice, check_avail_header, squallSuggestionsModal;
		var furtherSteps;

		var has_longPage ='';
		var longPage = '';

        if (store.get('redirect')) {
            has_longPage = 'redirect';
            longPage = null;
        }
		else if(store.get('serviceAvailable') && !store.get('show_business_type')) {
			stepOne = <ServiceAvailable />;
			className = "col-md-12";

			if(store.get('reseller').size) {
				furtherSteps = (<div className="stepContainer container" ><Reseller /></div>);
			}
			else {
				// if(
				// 	store.getIn(['input_address', 'serviceType']) == 'business'
				// 	    || (store.getIn(['input_address', 'serviceType']) == 'small_business'
                //         && (store.get('fiber_available') == true
                //             || store.get('fiber_xgspon_available') == true
                //             )
                //         && (store.getIn(['fiber_product', 'product_key']).indexOf('fusion_fiber') == -1
                //             && store.getIn(['fiber_product', 'product_key']).indexOf('xgspon_standard') == -1
                //             && store.getIn(['fiber_product', 'product_key']).indexOf('xgspon_fusion') == -1
                //             )
                //     )
				// ) {
				// 	hidden = <div>
				// 		<MduModal />
				// 	</div>;

                //     // This is depreciated
				// 	//if(store.get('business_seats') >= 5) {
				// 	//	furtherSteps = (<div className="container"><BusinessOptions /></div>);
				// 	//} else {
				// 		furtherSteps = (<div className="container"><BusinessSeats /></div>);
				// 	//}

				// }
                /*else*/ if (store.getIn(['input_address', 'serviceType']) == 'small_business' && store.get('service_type_manually_selected') == true) {
						has_longPage = 'smallbusiness';
						longPage = <SmallBusiness />;
                }
				else {
					if (store.getIn(['input_address', 'serviceType']) == 'residential' && store.get('fiber_xgspon_available') == true
                    && store.getIn(['fiber_product', 'product_key']).match('preorder') == null ) {
						has_longPage = 'xgspon';
						longPage = <FiberXGSPON />;
                    } else if (store.getIn(['input_address', 'serviceType']) == 'residential' && store.get('fiber_xgspon_available') == true
					&& store.getIn(['fiber_product', 'product_key']).match('preorder') != null) {
                        has_longPage = 'xgspon_fusion_preorder';
						longPage = <FiberXGSPONPreorder />;
					} else if (store.getIn(['input_address', 'serviceType']) == 'residential' && store.get('fiber_available') == true
						&& store.getIn(['fiber_product', 'product_key']).indexOf('fusion_fiber_preorder') == -1 ) {
						has_longPage = 'fiber';
						longPage = <FiberOnly />;
					} else if (store.getIn(['input_address', 'serviceType']) == 'residential' && store.get('fiber_available') == true
					&& store.getIn(['fiber_product', 'product_key']).indexOf('fusion_fiber_preorder') != -1) {
						has_longPage = 'pre_fiber';
						longPage = <FiberPreOrder />;
					} else if (store.getIn(['input_address', 'serviceType']) == 'residential' && tempProducts && tempProducts[0] && tempProducts[0]['product_key'].match('_ipbb_')) { // remove the x
						has_longPage = 'ipbb';
						longPage = <IPBB />;
					} else if (store.getIn(['input_address', 'serviceType']) == 'residential' && tempProducts && (tempProducts[0] && tempProducts[0]['technology'].match('dsl') || tempProducts[1] && tempProducts[1]['technology'].match('dsl'))) { // change to dsl and TEST with real DSL!!!!
						has_longPage = 'dsl';
						longPage = <DSL />;
					} else {
						furtherSteps =
							<div>
								<OrderStages />
								<Products />
							</div>;
						hidden = <div>
							<MduModal />
							</div>;
					}
				}
			}
		}
		else if(store.get('show_business_type')) {
            stepOne = (<div className="container"><BusinessSeats /></div>);
            has_longPage = 'business_seats';
            longPage = <BusinessSeats />;
		}
		else if(store.get('contactThanks')) {
			stepOne = <ContactThanks />;
		}
		else if(store.get('prequalInProgress')) {
			check_avail_header = <h1 className="check_avail_header">{t('common:check_avail_header')}</h1>;
			stepOne = <PrequalProgress />;
			hidden = <div>
				<MduModal />
				<SquallMduModal />
				<SquallSuggestionsModal />
				</div>;
			couponNotice = 	<CouponNotice />;
		}
		else if(store.get('qualTempUnavail')) {
			stepOne = <TempUnavail />
			furtherSteps = '';
		}
		else if(store.get('addressNotFound')) {
			stepOne = <AddressNotFound />
			furtherSteps = '';
		}
		else if(store.get('serviceUnavailableReason')) {

			stepOne = <NoService />;
			furtherSteps = '';
		}
		else {
			stepOne = <PrequalForm />;

			hidden = <div>
				<MduModal />
				<SquallMduModal /></div>;
			couponNotice =
				<CouponNotice />
				;
		}

		var footerElm = document.getElementsByClassName("footer-wrapper");

		if (has_longPage!='') {
			if (footerElm && footerElm[0] && footerElm[0].style) {
				footerElm[0].style.display = "none";
			}
			const navBlock = document.getElementById('block-system-main-menu');
			const phoneBlock = document.getElementById('block-block-31');
			if (navBlock) {
				navBlock.style.display = "none";
			}
			if (phoneBlock) {
				phoneBlock.style.display = "none";
			}

		} else {
			if (footerElm && footerElm[0] && footerElm[0].style){
				footerElm[0].style.display = "block";
			}
		}
		var errorMessage;
		if(store.get('errorMessage')) {
			errorMessage = <div className="alert alert-warning">{t(store.get('errorMessage'))}</div>;
		}

		return (
			<div>
				{(has_longPage!='' ? false : check_avail_header)}
				{(has_longPage!='' ? false : couponNotice)} {/* This may be OK to remove condition if it can be just on top */}
				{errorMessage}
				{(has_longPage != '' ? longPage :(
						<div className="row">
							<div className={className}>
								<div className="stepContainer container">
									{stepOne}
								</div>
								{furtherSteps}
							</div>
						</div>
				))}
				{hidden}
			</div>
		)
  }
});


export default  translate('common', { wait: true })(Availability);